// @flow
import { useState } from 'react';
import CustomTooltip from '../../../../../components/base/Tooltip/Tooltip';

import icon from './../../../../../assets/icons/icon-information.svg';
import iconDark from './../../../../../assets/icons/icon-information-dark.svg';

type Props = {
    text?: string, // text to show
    placement?:string
}
export default function InfoMessage({ text = '', placement = 'right' }:Props) {
    const [image, setImage] = useState(icon);

    const changeIcon = (ic) => {
        setImage(ic);
    };

    return <CustomTooltip force={true} text={text} placement={placement}
        className='info-message'><img onMouseLeave={() => changeIcon(icon)} onMouseEnter={() => changeIcon(iconDark)} className='info-icon'
            alt='info'
            src={image}/></CustomTooltip>;
}
